export default "__VITE_ASSET__Ou41y0LX__"